import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectUserState = (state: AppState) =>
  state.user;


export const selectUser = createSelector(
  selectUserState,
  (state) => state.currentUser
);
export const selectUserBetaFe = createSelector(
  selectUserState,
  (state) => state.currentUser.BetaFe
);
export const selectCurrentLang = createSelector(
  selectUserState,
  (state) => state.currentLang
);
export const selectTechnicians = createSelector(
  selectUserState,
  (state) => state.technicians
);
export const selectTechnician = createSelector(
  selectUserState,
  (state) => state.technician
);
export const selectCurrentTechnician = createSelector(
  selectUserState,
  (state) => state.currentTechnician
);
export const selectTechnicianAssigned = createSelector(
  selectUserState,
  (state) => state.userTechnicianAssigned
);
export const selectCustomers = createSelector(
  selectUserState,
  (state) => state.customers
);
export const selectCustomersLoading = createSelector(
  selectUserState,
  (state) => state.customersLoading
);
export const selectCustomersPage = createSelector(
  selectUserState,
  (state) => state.customerPaging
);
export const selectCustomerInvited = createSelector(
  selectUserState,
  (state) => state.customerInvited
);
export const selectRoleExplainedTechnician = createSelector(
  selectUserState,
  (state) => state.isTechnician
);
export const selectIsImpersMode = createSelector(
  selectUserState,
  (state) => state.isImpersMode
);
export const selectIsDraftMode = createSelector(
  selectUserState,
  (state) => state.isDraftMode
);
export const selectIsUser = createSelector(
  selectUserState,
  (state) => state.isUser
);
export const selectNotificationMaintenance = createSelector(
  selectUserState,
  (state) => state.notificationMaintenance
);
export const selectSearchFailedGetByCode = createSelector(
  selectUserState,
  (state) => state.searchFailed
);
export const selectReadyToImpers = createSelector(
  selectUserState,
  (state) => state.readyToImpers
);
export const selectExitBeta = createSelector(
  selectUserState,
  (state) => state.exitBeta
);
export const selectPrivacyNoteList = createSelector(
  selectUserState,
  (state) => state.privacyNoteList
);
export const selectReleaseNoteList = createSelector(
  selectUserState,
  (state) => state.releaseNoteList
);
export const selectRatingLoading = createSelector(
  selectUserState,
  (state) => state.ratingLoading
);
export const selectRatingSuccess = createSelector(
  selectUserState,
  (state) => state.ratingSuccess
);
export const selectAskNextRatingDate = createSelector(
  selectUserState,
  (state) => state.askNextRatingDate
);